import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Ticket, Euro, Users, Gift } from "lucide-react";

function Stat({ icon: Icon, label, value, color, testId }) {
  return (
    <div className="p-4 rounded-xl bg-[#0B0C10] border border-white/10">
      <div className="text-xs uppercase tracking-widest text-slate-400 flex items-center gap-1"><Icon className="w-3 h-3" /> {label}</div>
      <div className={`text-3xl font-black mt-1 ${color}`} data-testid={testId}>{value}</div>
    </div>
  );
}

export function SalesStats({ pin, refreshKey }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const load = () => api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
    load();
    const iv = setInterval(load, 10000);
    return () => clearInterval(iv);
  }, [pin, refreshKey]);

  if (!stats) return null;
  const active = stats.games.find((g) => ["lobby", "live", "paused"].includes(g.status));
  const fmt = (n) => `€${Number(n).toFixed(2)}`;

  return (
    <div className="p-6 rounded-2xl bg-[#12141D] border border-[#FFD700]/30" data-testid="sales-stats">
      <div className="text-xs uppercase tracking-[0.3em] text-[#FFD700]">Verkoop</div>
      <h2 className="text-2xl font-bold mt-1" style={{ fontFamily: "Unbounded, sans-serif" }}>
        {active ? active.title : "Geen actieve ronde"}
      </h2>
      {active && (
        <div className="mt-4 grid grid-cols-2 md:grid-cols-4 gap-3">
          <Stat icon={Ticket} label="Verkocht" value={active.sold} color="text-[#FFD700]" testId="stat-sold" />
          <Stat icon={Euro} label="Omzet" value={fmt(active.revenue)} color="text-[#00E676]" testId="stat-revenue" />
          <Stat icon={Users} label="Spelers" value={active.players} color="text-[#00F0FF]" testId="stat-players" />
          <Stat icon={Gift} label="Testkaarten" value={active.free} color="text-[#FF007F]" testId="stat-free" />
        </div>
      )}
      <div className="mt-4 flex flex-wrap gap-6 text-sm text-slate-400 border-t border-white/10 pt-4">
        <span>Totaal alle rondes: <b className="text-slate-100" data-testid="stat-total-sold">{stats.total_sold}</b> kaarten</span>
        <span>Totale omzet: <b className="text-[#00E676]" data-testid="stat-total-revenue">{fmt(stats.total_revenue)}</b></span>
      </div>
    </div>
  );
}
